import script from "./PaywallBenefits.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallBenefits.vue?vue&type=script&setup=true&lang=js"

import "./PaywallBenefits.vue?vue&type=style&index=0&id=33da5afd&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33da5afd"]])

export default __exports__